import { ApiError, requestJson, type ApiEnvelope } from '@shared/api/http';

function ensureSuccess<T>(body: ApiEnvelope<T>, fallbackMessage: string): ApiEnvelope<T> {
  if (body.status && body.status !== 'Success') {
    throw new ApiError(body.message ?? fallbackMessage, body.statusCode ?? 500, body);
  }
  return body;
}

export async function blockUser(
  blockedUserId: number,
  reason: string,
  baseUrl?: string,
): Promise<void> {
  const body = await requestJson<ApiEnvelope<unknown>>('/blacklist/add', {
    method: 'POST',
    baseUrl,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      blockedUserId,
      reason,
    }),
  });
  ensureSuccess(body, 'Failed to block user');
}
